import React, { useRef, useState, useEffect } from 'react';
import "./Experience.css";
function useInView() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setInView(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}
const features = [{
  icon: '01',
  title: 'Live Craft Brewery',
  desc: 'Watch our brewmasters at work behind the glass walls of our in-house brewery. Every batch brewed with obsessive precision.'
}, {
  icon: '02',
  title: 'Open Kitchen Theatre',
  desc: 'Our chefs perform in full view. Flames, aromas, and culinary theatre - dinner as spectacle.'
}, {
  icon: '03',
  title: 'Rooftop Terrace',
  desc: 'Elevated al fresco dining under the Mysuru sky. Golden hour views with golden brews in hand.'
}, {
  icon: '04',
  title: 'The Cellar Lounge',
  desc: 'An intimate underground bar for whisky, aged spirits, and curated cocktails. By reservation.'
}];
export default function Experience() {
  const [ref, inView] = useInView();
  return <section id="experience" ref={ref} className="experience__auto-1">
      {/* Background noise */}
      <div style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.03'/%3E%3C/svg%3E")`,
      pointerEvents: 'none'
    }} />

      {/* Geometric lines */}
      <div className="experience__auto-2" />
      <div className="experience__auto-3" />

      <div className="experience__auto-4">
        <div className="experience__auto-5">
          {/* Left text */}
          <div style={{
          opacity: inView ? 1 : 0,
          transform: inView ? 'translateY(0)' : 'translateY(30px)',
          transition: 'all 0.8s ease'
        }}>
            <div className="experience__auto-6">
              <div className="experience__auto-7" />
              <span className="experience__auto-8">The Space</span>
            </div>
            <h2 className="experience__auto-9">
              An Experience<br />
              <span className="experience__auto-10">Beyond the Pint</span>
            </h2>
            <p className="experience__auto-11">
              Wild Elephant is not just a bar - it's an expedition. Spread across multiple levels, each space carries its own wild character. Come for the beer, stay for the atmosphere, return for the stories.
            </p>
            <p className="experience__auto-12">
              Capacity for 220 guests across three distinct zones. Private event spaces available.
            </p>

            <div className="experience__auto-13">
              <StatPill label="Mon-Thu" value="12pm-12am" />
              <StatPill label="Fri-Sun" value="12pm-2am" />
            </div>
          </div>

          {/* Right feature grid */}
          <div className="experience__auto-14">
            {features.map((f, i) => <FeatureCard key={i} feature={f} delay={i * 0.1} inView={inView} />)}
          </div>
        </div>
      </div>
    </section>;
}
function FeatureCard({
  feature,
  delay,
  inView
}) {
  const [hov, setHov] = useState(false);
  return <div onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)} style={{
    background: hov ? 'rgba(26, 8, 8, 0.7)' : 'rgba(107, 26, 26, 0.3)',
    padding: 'clamp(24px, 3vw, 36px)',
    transition: 'background 0.3s ease',
    opacity: inView ? 1 : 0,
    transform: inView ? 'scale(1)' : 'scale(0.95)',
    transitionDuration: '0.6s',
    transitionDelay: `${delay + 0.2}s`
  }}>
      <div className="experience__auto-15">
        {feature.icon}
      </div>
      <h3 className="experience__auto-16">
        {feature.title}
      </h3>
      <p className="experience__auto-17">
        {feature.desc}
      </p>
    </div>;
}
function StatPill({
  label,
  value
}) {
  return <div className="experience__auto-18">
      <div className="experience__auto-19">
        {label}
      </div>
      <div className="experience__auto-20">
        {value}
      </div>
    </div>;
}
